import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonDiscard: React.FC<MprcButtonProps> = ({ text, title, color = "muted", variant = "text", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonDiscard.text;
    const lTitle = title || theme.buttons.ButtonDiscard.title;

    return (
        <MprcButton
            {...rest}
            color={color}
            variant={variant}
            title={lTitle}
            text={lText}
        />
    );
};
